export default {
    blocks: {
        title: 'Title',
        image: 'Picture',
        contactPerson: 'Contact person',
        links: 'Links to',
        description: 'Description',
        technologicalOpportunities: 'Technological Opportunities',
        marketOpportunities: 'Market Opportunities',
        capabilities: 'Capabilities & Assets'
    },

    labels: {
        title: 'Titel',
        description: 'Short description',
        technologicalOpportunities: 'Short description',
        marketOpportunities: 'Short description',
        capabilities: 'Short description',
        innovationProjects: 'Innovation projects',
        macrotrends: 'Macro-Trends',
        trendradars: 'Trend radars',
        contactPerson: 'Contact person',
        state: 'State'
    },

    tooltip: {
        state:
      'The innovation field is only visible to the users of the Trendmanager when the status is ' +
      '"published". The selected users of the team can already see and edit the innovation ' +
      'field in "draft" status.'
    },

    empty: {
        contactPerson: 'Unfortunately no users could be found',
        macrotrends: 'Unfortunately no macro-trends could be found',
        trendradars: 'Unfortunately no trend radars could be found',
        innovationProjects: 'Unfortunately no innovation projects could be found'
    },

    descriptions: {
        description:
      'Which future thesis forms the basis for the field of innovation? What is to be achieved with the field ' +
      'of innovation?',
        technologicalOpportunities:
      'Which technological developments or technology-based trends form the basis for innovation projects ' +
      'within the field of innovation?',
        marketOpportunities:
      'Which current and future needs of consumers and customers does the field of innovationaddress?',
        capabilities:
      'Which competences & resources are needed? Which ones already exist and which ones still need to be developed?'
    },

    buttons: {
        reset: 'Cancel',
        submit: 'Save'
    },

    validation: {
        title: {
            required: 'Please enter a title',
            maxLength: 'The title must not contain more than 100 characters',
            minLength: 'The title must not contain less than 3 characters'
        },
        description: {
            required: 'Please enter a description',
            maxLength: 'The description must not contain more than 1000 characters'
        },
        technologicalOpportunities: {
            maxLength: 'The technological opportunities must not contain more than 1000 characters'
        },
        marketOpportunities: {
            maxLength: 'The market opportunities must not contain more than 1000 characters'
        },
        capabilities: {
            maxLength: 'The capabilities must not contain more than 1000 characters'
        },
        image: {
            size: 'The image must not be larger than 8MB',
            mimetype: 'Please only use GIF/JPG/PNG'
        }
    }
}
